<template>
  <div class="page">
    <header-title :title="title"></header-title>
    <div class="mass-change-box">
      <div
        class="step step1 row"
        :class="{
          'step-change': form.timeType && form.productionLine,
        }"
      >
        <i class="seled"></i>

        <div class="w col">
          <div class="label">Please select check box</div>
          <div class="nr">
            <a-radio-group
              size="large"
              v-model:value="form.timeType"
              button-style="solid"
            >
              <a-radio-button
                v-for="item in timeTypeList"
                :key="item.value"
                :value="item.value"
              >
                {{ item.text }}
              </a-radio-button>
            </a-radio-group>
          </div>
        </div>
        <div class="w col right-w">
          <div class="label">Select Shift No</div>
          <div class="nr">
            <div class="item-input-wrapper">
              <a-select
                size="large"
                v-model:value="form.shift_no"
                style="width: 100%"
              >
                <a-select-option
                  v-for="x in shiftNoItem"
                  :key="x.text"
                  :value="x.value"
                >
                  {{ x.text }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        <div class="w col right-w">
          <div class="label">Select Production Line</div>
          <div class="nr">
            <div class="item-input-wrapper">
              <a-select
                size="large"
                v-model:value="form.productionLine"
                style="width: 100%"
              >
                <a-select-option
                  v-for="x in productionLineItem"
                  :key="x.netGrpName"
                  :value="x.netGrpName"
                >
                  {{ x.netGrpName }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
      </div>
      <div class="step step2" :class="{ 'step-change': showTimeRange }">
        <i class="seled"></i>
        <div
          class="w"
          :class="{ hidden: !(form.timeType || form.productionLine) }"
        >
          <div class="label">
            <span class="t">Select Work Station</span>

            <a-checkbox
              v-model:checked="state.checkAll"
              :indeterminate="state.indeterminate"
              @change="onCheckAllChange"
              style="padding-left: 30px"
            >
              Check all
            </a-checkbox>
          </div>
          <div class="btn-group nr">
            <a-checkbox-group
              v-model:value="state.checkedCodes"
              :options="state.regionCodes"
            />
          </div>
        </div>
      </div>
      <div
        class="step step3 row"
        :class="{ 'step-change': form.timeRange != null }"
      >
        <i class="seled"></i>
        <div
          class="w col"
          :class="{
            hidden:
              !showTimeRange ||
              form.productionLine == null ||
              form.productionLine == '',
          }"
        >
          <div class="label">Select Time Range</div>
          <div class="nr">
            <a-range-picker
              size="large"
              v-model:value="form.timeRange"
              show-time
            />
          </div>
        </div>
        <div
          class="w col"
          :class="{
            hidden:
              !showTimeRange ||
              form.productionLine == null ||
              form.productionLine == '',
          }"
        >
          <div class="nr">
            <a-button
              type="primary"
              size="large"
              :loading="saveLoading"
              :disabled="
                form.timeRange == null ||
                !showTimeRange ||
                form.productionLine == null ||
                form.productionLine == ''
              "
              @click="save()"
            >
              Save
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import HeaderTitle from '@/layout/header-title'
  import request from '@/utils/request'
  import { computed, ref, reactive, createVNode, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  // import { CheckOutlined } from '@ant-design/icons-vue'
  import { Modal } from 'ant-design-vue'
  import dayjs from 'dayjs'
  const title = 'Work Calendar Mass Change'
  const route = useRoute()
  const router = useRouter()
  const timeTypeList = [
    { text: 'Over Time', value: 1 },
    { text: 'Off Time', value: 2 },
  ]
  const formatDate = 'YYYY/MM/DD'
  const form = ref({
    timeType: route.query.type * 1 || null,
    productionLine: route.query.grp || null,
    shift_no: '',
    timeRange: [
      dayjs(dayjs().format(formatDate)),
      dayjs(dayjs().add(7, 'day').format(formatDate), formatDate),
    ],
  })

  const state = reactive({
    regionCodes: [],
    checkedCodes: route.query.reg ? [route.query.reg] : [],
    indeterminate: true,
    checkAll: false,
  })
  const shiftNoItem = [
    { value: 1, text: 1 },
    { value: 2, text: 2 },
    { value: 3, text: 3 },
  ]
  const showTimeRange = computed(() => {
    return state.checkedCodes.length > 0
  })
  const productionLineItem = ref([])

  const getWorkStationList = (group) => {
    request({
      url: '/api/masterdata/getPRegionsFromGrpId',
      params: {
        netGroupId: group,
      },
    }).then((res) => {
      if (res.body && res.body.length) {
        state.regionCodes = res.body.map((item) => {
          return item.regionCode
        })
      } else {
        state.regionCodes = []
      }
    })
  }
  const onCheckAllChange = (e) => {
    Object.assign(state, {
      checkedCodes: e.target.checked ? state.regionCodes : [],
      indeterminate: false,
    })
  }
  watch(
    () => state.checkedCodes,
    (val) => {
      state.indeterminate =
        !!val.length && val.length < state.regionCodes.length
      state.checkAll = val.length === state.regionCodes.length
    }
  )
  const load = () => {
    request({
      url: '/api/masterdata/queryNetGrpIds',
    }).then((res) => {
      productionLineItem.value = res.body || []
    })
    if (route.query.grp != null) {
      getWorkStationList(route.query.grp)
    }
  }
  load()
  const saveLoading = ref(false)
  const save = () => {
    var rawData = {
      regionCodes: state.checkedCodes.join(','),
      start: dayjs(form.value.timeRange[0]).valueOf(),
      end: dayjs(form.value.timeRange[1]).valueOf(),
      timeType: form.value.timeType,
      shift_no: form.value.shift_no,
    }
    saveLoading.value = true
    request({
      url: '/api/scheduling/massUploadCalendar',
      method: 'post',
      params: rawData,
    })
      .then((res) => {
        var tempHtmlArr = []
        for (var i = 0; i < res.body.length; i++) {
          tempHtmlArr.push(
            createVNode(
              'span',
              {
                style: {
                  padding: '5px 0 5px 10px',
                  display: 'block',
                },
              },
              res.body[i]
            )
          )
        }
        Modal.confirm({
          width: 600,
          title: 'Following work station calendars are updated successfully',
          content: createVNode('div', { class: 'tips' }, tempHtmlArr),
          onOk() {
            if (route.query.form) {
              router.push({
                path: route.query.form,
                query: {
                  ot: true,
                  name: route.query.name,
                },
              })
            }
          },
        })
      })
      .finally(() => {
        saveLoading.value = false
      })
  }
</script>
<style lang="less" scoped>
  @import '../less/mass-change.less';
  .page {
    height: calc(100% - 46px);
  }
  :deep(.ant-modal-confirm-content) {
    .tips {
      .tips-list {
        position: relative;
        padding: 5px 0 5px 10px;
        display: block;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          display: block;
          width: 4px;
          height: 4px;
          background: #ccc;
        }
      }
    }
  }
</style>
